//--------------- IMPORTAÇÃOES ---------------//
import api from "../../../services/api";



//--------------- FUNÇÃO ASSÍNCRONA LOAD USERS SERVICE ---------------//
// Responsável por requisitar à API os Usuários existentes
export default async function checkService() {
    try {
        await api.get("/auth/check");
        return true;
    } catch (err) {
        console.error("Erro de Check-in", err);
        return false;
    }
}